export const defaultGeneralLoadingPaneStyleProps = {
  position: "initial",
  width: "100%",
  height: "100%",
  left: "0%",
  top: "0%",
  borderRadius: "0 0 4px 4px",
  borderWidth: "0px",
  backgroundColor: "#315FA2"
};